<template>
  <div>
    <case-update-card
      :info-item="request"
      :icon="'mdi-archive'"
      :header="request.requestTypeName"
      :code-display-name="local.caseFile.cards.request.codeDisplayName"
      :code="request.requestCode"
      :status=" request.requestStatusName"
      :status-display-name="local.caseFile.cards.request.statusDisplayName"
      :date="request.requestDate"
      :date-display-name="local.caseFile.cards.request.dateDisplayName"
      :has-actions="true"
      :court-name="request.courtName"
      :sub-circle-name="request.subCircleName"
      :clickable="!request.isBankruptcyMigrated"
    >
      <template
        v-if="requestType"
        slot="actions"
        slot-scope="{}"
      >
        <v-menu v-if="!request.isBankruptcyMigrated" offset-y>
          <template v-slot:activator="{ on }">
            <v-icon
              large
              v-on="on"
            >
              mdi-dots-vertical
            </v-icon>
          </template>
          <v-list>
            <v-list-item>
              <v-list-item-title>
                <router-link :to="getView()">
                  <naj-button
                    text
                    type="button"
                    size="small"
                  >
                    {{ local.common.show }}
                  </naj-button>
                </router-link>
              </v-list-item-title>
            </v-list-item>

            <v-list-item v-if="request.requestStatusId == requestStatus.NotCompleted">
              <v-list-item-title>
                <naj-button
                  text
                  type="button"
                  size="small"
                  @click="showRequestInCompleteReasons"
                >
                  {{ local.common.inCompleteReasons }}
                </naj-button>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-chip v-if="request.isBankruptcyMigrated" outlined color="primary" class="separated-items-chip mt-2">
          {{ local.home.tabCommon.isBankruptcyRequestMigrated }}
        </v-chip>
      </template>
    </case-update-card>

    <naj-confirmation
      :show-modal="requestInCompleteReasonsModal"
      :max-width="750"
      :is-persistent="false"
      :title="local.common.inCompleteReasons"
      :close-btn-label="local.common.close"
      @cancel="hideRequestInCompleteReasons"
    >
      <template slot="message-content">
        <v-row>
          <v-col>
            <naj-alert type="information">
              <template
                v-if="request"
                slot="content"
              >
                <span v-if="request.notes"> {{ request.notes }}</span>
                <span v-else> {{ local.common.noReasonsToDisplay }} </span>
              </template>
            </naj-alert>
          </v-col>
        </v-row>
      </template>
    </naj-confirmation>
  </div>
</template>

<script>
import { toHijriDate, getTimePart } from '@/helpers/utils';
import CaseUpdateCard from './case-update-card.vue';
import { RequestTypesIds, requestStatus } from '@/helpers/enum';
import { createNamespacedHelpers } from 'vuex';

const { mapActions: mapGlobalActions } = createNamespacedHelpers('GlobalModule');
export default {
  name: 'RequestCard',
  components: { CaseUpdateCard },
  props: {
    request: {
      type: Object,
      required: true,
    },
    isPega: {
      type: [String, Boolean],
      required: true,
    },
    isFromNonCaseParty: {
      type: Boolean,
      required: false,
    },
    parentRequestObjectKey: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      requestStatus,
      requestInCompleteReasonsModal: false,
      socialId: null,
    };
  },
  computed: {
    requestType() {
      return RequestTypesIds[this.request.requestTypeId];
    },
  },
  methods: {
    ...mapGlobalActions(['getUserInfo']),
    toHijriDate,
    getTimePart,
    getView() {
      if (this.requestType) {
        return {
          name: 'view-case-related-request',
          params: {
            requestType: this.requestType,
            requestObjectKey: this.request.objectKey,
          },
          query: {
            isPega: String(this.isPega),
            isFromNonCaseParty: this.isFromNonCaseParty,
            parentRequestObjectKey: this.parentRequestObjectKey,
          },
        };
      }
      return null;
    },
    showRequestInCompleteReasons() {
      this.requestInCompleteReasonsModal = true;
    },
    hideRequestInCompleteReasons() {
      this.requestInCompleteReasonsModal = false;
    },
  },
};

</script>
<style scoped>
.header-text {
  font-size: 18px;
}

::v-deep .case-update-card-header {
  color: var(--app-dark-primary-color);
  font-size: 25px;
}

.separated-items-chip {
  margin-left: 4px !important;
  border-radius: 20px !important;
  height: 30px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  font-size: x-small !important;
}
</style>
